import React from 'react';
import styled, {css} from 'styled-components';
import Parcelasdiv from  './Parcelasdiv';

import imgParcela1 from '../../images/PARCELAS/Parcela1/PARCELA 1.jpg';
import imgPlano1 from '../../images/PARCELAS/Parcela1/Plano 1.jpg';

import imgParcela2 from '../../images/PARCELAS/Parcela2/PARCELA 2.jpg';
import imgPlano2 from '../../images/PARCELAS/Parcela2/Plano 2.jpg';

import imgParcela3 from '../../images/PARCELAS/Parcela3/PARCELA 3.jpg';
import imgPlano3 from '../../images/PARCELAS/Parcela3/Plano 3.jpg';

import imgParcela4 from '../../images/PARCELAS/Parcela4/PARCELA 4.jpg';
import imgPlano4 from '../../images/PARCELAS/Parcela4/Plano 4.jpg';

import imgParcela5 from '../../images/PARCELAS/Parcela5/PARCELA 5.jpg';
import imgPlano5 from '../../images/PARCELAS/Parcela5/Plano 5.jpg';

import imgParcela6 from '../../images/PARCELAS/Parcela6/PARCELA 6.jpg';
import imgPlano6 from '../../images/PARCELAS/Parcela6/Plano 6.jpg';

import imgParcela7 from '../../images/PARCELAS/Parcela7/PARCELA 7.jpg';
import imgPlano7 from '../../images/PARCELAS/Parcela7/Plano 7.jpg';

import imgParcela8 from '../../images/PARCELAS/Parcela8/PARCELA 8.jpg';
import imgPlano8 from '../../images/PARCELAS/Parcela8/Plano 8.jpg';

import imgParcela9 from '../../images/PARCELAS/Parcela9/PARCELA 9.jpg';
import imgPlano9 from '../../images/PARCELAS/Parcela9/Plano 9.jpg';

import imgParcela10 from '../../images/PARCELAS/Parcela10/PARCELA 10.jpg';
import imgPlano10 from '../../images/PARCELAS/Parcela10/Plano 10.jpg';

import imgParcela11 from '../../images/PARCELAS/Parcela11/PARCELA 11.jpg';
import imgPlano11 from '../../images/PARCELAS/Parcela11/Plano 11.jpg';

import imgParcela12 from '../../images/PARCELAS/Parcela12/PARCELA 12.jpg';
import imgPlano12 from '../../images/PARCELAS/Parcela12/Plano 12.jpg';

import imgParcela13 from '../../images/PARCELAS/Parcela13/PARCELA 13.jpg';
import imgPlano13 from '../../images/PARCELAS/Parcela13/Plano 13.jpg';

import imgParcela14 from '../../images/PARCELAS/Parcela14/PARCELA 14.jpg';
import imgPlano14 from '../../images/PARCELAS/Parcela14/Plano 14.jpg';

import imgParcela15 from '../../images/PARCELAS/Parcela15/PARCELA 15.jpg';
import imgPlano15 from '../../images/PARCELAS/Parcela15/Plano 15.jpg';

import imgParcela16 from '../../images/PARCELAS/Parcela16/PARCELA 16.jpg';
import imgPlano16 from '../../images/PARCELAS/Parcela16/Plano 16.jpg';

import imgParcela17 from '../../images/PARCELAS/Parcela17/PARCELA 17.jpg';
import imgPlano17 from '../../images/PARCELAS/Parcela17/Plano 17.jpg';

import imgParcela18 from '../../images/PARCELAS/Parcela18/PARCELA 18.jpg';
import imgPlano18 from '../../images/PARCELAS/Parcela18/Plano 18.jpg';

import imgParcela19 from '../../images/PARCELAS/Parcela19/PARCELA 19.jpg';
import imgPlano19 from '../../images/PARCELAS/Parcela19/Plano 19.jpg';

import imgParcela20 from '../../images/PARCELAS/Parcela20/PARCELA 20.jpg';
import imgPlano20 from '../../images/PARCELAS/Parcela20/Plano 20.jpg';

import imgParcela21 from '../../images/PARCELAS/Parcela21/PARCELA 21.jpg';
import imgPlano21 from '../../images/PARCELAS/Parcela21/Plano 21.jpg';

import imgParcela22 from '../../images/PARCELAS/Parcela22/PARCELA 22.jpg';
import imgPlano22 from '../../images/PARCELAS/Parcela22/Plano 22.jpg';

import imgParcela23 from '../../images/PARCELAS/Parcela23/Parcelas 23.jpg';
import imgPlano23 from '../../images/PARCELAS/Parcela23/Plano 23.jpg';

import imgParcela24 from '../../images/PARCELAS/Parcela24/PARCELA 24.jpg';
import imgPlano24 from '../../images/PARCELAS/Parcela24/Plano 24.jpg';

import imgParcela25 from '../../images/PARCELAS/Parcela25/PARCELA 25.jpg';
import imgPlano25 from '../../images/PARCELAS/Parcela25/Plano 25.jpg';

import imgParcela26 from '../../images/PARCELAS/Parcela26/PARCELA 26.jpg';
import imgPlano26 from '../../images/PARCELAS/Parcela26/Plano 26.jpg';

import imgParcela27 from '../../images/PARCELAS/Parcela27/PARCELA 27.jpg';
import imgPlano27 from '../../images/PARCELAS/Parcela27/Plano 27.jpg';

import imgParcela28 from '../../images/PARCELAS/Parcela28/PARCELA 28.jpg';
import imgPlano28 from '../../images/PARCELAS/Parcela28/Plano Parcela 28.jpg';

import imgParcela29 from '../../images/PARCELAS/Parcela29/PARCELA 29.jpg';
import imgPlano29 from '../../images/PARCELAS/Parcela29/Plano 29.jpg';

import imgParcela30 from '../../images/PARCELAS/Parcela30/PARCELA 30.jpg';
import imgPlano30 from '../../images/PARCELAS/Parcela30/Plano 30.jpg';

import imgParcela63 from '../../images/PARCELAS/Parcela63/PARCELA 63.jpg';
import imgPlano63 from '../../images/PARCELAS/Parcela63/Plano 63.jpg';

import imgParcela119 from '../../images/PARCELAS/Parcela119/PARCELA 119.jpg';
import imgPlano119 from '../../images/PARCELAS/Parcela119/Plano 119.jpg';

const Parcelas = ({ viewParcelas }) => {

    return(
        <BodyParcelasCSS viewParcelas = { viewParcelas }>
            <h1>PARCELAS</h1>
            <Parcelasdiv 
                number1Parcela = "Parcela 1"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela1}
                imgPlano = {imgPlano1}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 2"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela2}
                imgPlano = {imgPlano2}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 3"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela3}
                imgPlano = {imgPlano3}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 4"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela4}
                imgPlano = {imgPlano4}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 5"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela5}
                imgPlano = {imgPlano5}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 6"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela6}
                imgPlano = {imgPlano6}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 7"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela7}
                imgPlano = {imgPlano7}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 8"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela8}
                imgPlano = {imgPlano8}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 9"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela9}
                imgPlano = {imgPlano9}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 10"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela10}
                imgPlano = {imgPlano10}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 11"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela11}
                imgPlano = {imgPlano11}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 12"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela12}
                imgPlano = {imgPlano12}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 13"
                descripcionParcela = "Parcela con un área de 5.012 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.120.000 Aprox"
                imgParcela = {imgParcela13}
                imgPlano = {imgPlano13}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 14"
                descripcionParcela = "Parcela con un área de 4.872 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.720.000 Aprox"
                imgParcela = {imgParcela14}
                imgPlano = {imgPlano14}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 15"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.320.000 Aprox"
                imgParcela = {imgParcela15}
                imgPlano = {imgPlano15}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 16"
                descripcionParcela = "Parcela con un área de 4.907 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$49.070.000 Aprox"
                imgParcela = {imgParcela16}
                imgPlano = {imgPlano16}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 17"
                descripcionParcela = "Parcela con un área de 4.899 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.990.000 Aprox"
                imgParcela = {imgParcela17}
                imgPlano = {imgPlano17}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 18"
                descripcionParcela = "Parcela con un área de 4.879 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.790.000 Aprox"
                imgParcela = {imgParcela18}
                imgPlano = {imgPlano18}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 19"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela19}
                imgPlano = {imgPlano19}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 20"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela20}
                imgPlano = {imgPlano20}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 21"
                descripcionParcela = "Parcela con un área de 4.570 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$45.700.000 Aprox"
                imgParcela = {imgParcela21}
                imgPlano = {imgPlano21}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 22"
                descripcionParcela = "Parcela con un área de 5.267 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$52.670.000 Aprox"
                imgParcela = {imgParcela22}
                imgPlano = {imgPlano22}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 23"
                descripcionParcela = "Parcela con un área de 5.068 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.680.000 Aprox"
                imgParcela = {imgParcela23}
                imgPlano = {imgPlano23}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 24"
                descripcionParcela = "Parcela con un área de 4.850 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.500.000 Aprox"
                imgParcela = {imgParcela24}
                imgPlano = {imgPlano24}
            />
             <Parcelasdiv 
                number1Parcela = "Parcela 25"
                descripcionParcela = "Parcela con un área de 4.907 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$49.070.000 Aprox"
                imgParcela = {imgParcela25}
                imgPlano = {imgPlano25}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 26"
                descripcionParcela = "Parcela con un área de 4.820 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$48.200.000 Aprox"
                imgParcela = {imgParcela26}
                imgPlano = {imgPlano26}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 27"
                descripcionParcela = "Parcela con un área de 4.560 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$45.600.000 Aprox"
                imgParcela = {imgParcela27}
                imgPlano = {imgPlano27}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 28"
                descripcionParcela = "Parcela con un área de 5.775 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$57.750.000 Aprox"
                imgParcela = {imgParcela28}
                imgPlano = {imgPlano28}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 29"
                descripcionParcela = "Parcela con un área de 5.150 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$51.500.000 Aprox"
                imgParcela = {imgParcela29}
                imgPlano = {imgPlano29}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 30"
                descripcionParcela = "Parcela con un área de 5.000 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$50.000.000 Aprox"
                imgParcela = {imgParcela30}
                imgPlano = {imgPlano30}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 63"
                descripcionParcela = "Parcela con un área de 4.905 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$49.050.000 Aprox"
                imgParcela = {imgParcela63}
                imgPlano = {imgPlano63}
            />
            <Parcelasdiv 
                number1Parcela = "Parcela 119"
                descripcionParcela = "Parcela con un área de 4.905 mts cuadrados, con amplia Zona Verde, GLAMPING tipo Chalet construido en madera y todos los beneficios que te ofrece la naturaleza"
                precioParcela = "$49.050.000 Aprox"
                imgParcela = {imgParcela119}
                imgPlano = {imgPlano119}
            />
        </BodyParcelasCSS>
    )
}
export default Parcelas;

const BodyParcelasCSS = styled.div`
    background-color: white;
    opacity: 1;
    height:88%;
    z-index:5;
    top: 12%;
    display: none;
    position:relative;
    overflow:scroll;
    ${props => props.viewParcelas === true && css`
    display: block;
    `}
    h1 {
        font-family: widen latin;
        font-size: 40px;
        margin:4%;
        margin-bottom:2%;
        height:45px;
        background-color: #003333;
        color: #fff;
        opacity: 1;
        @media(max-width:938px) {
            margin:1%;
            margin-top: 4%;
            margin-bottom: 6%;
        }
    }
`;